import { memo, type ReactNode, useState } from 'react';

import BluePicture1 from '../../../../assets/images/learning-resources/blue1.jpg';
import BluePicture2 from '../../../../assets/images/learning-resources/blue2.jpg';
import GoldPicture1 from '../../../../assets/images/learning-resources/gold1.jpg';
import GoldPicture2 from '../../../../assets/images/learning-resources/gold2.jpg';
import GreenPicture1 from '../../../../assets/images/learning-resources/green1.jpg';
import GreenPicture2 from '../../../../assets/images/learning-resources/green2.jpg';
import MeshPicture1 from '../../../../assets/images/learning-resources/mesh1.jpg';
import MeshPicture2 from '../../../../assets/images/learning-resources/mesh2.jpg';
import OrangePicture1 from '../../../../assets/images/learning-resources/orange1.jpg';
import OrangePicture2 from '../../../../assets/images/learning-resources/orange2.jpg';
import PinkPicture1 from '../../../../assets/images/learning-resources/pink1.jpg';
import PurplePicture1 from '../../../../assets/images/learning-resources/purple1.jpg';
import PurplePicture2 from '../../../../assets/images/learning-resources/purple2.jpg';
import RedPicture1 from '../../../../assets/images/learning-resources/red1.jpg';
import RedPicture2 from '../../../../assets/images/learning-resources/red2.jpg';
import YellowPicture1 from '../../../../assets/images/learning-resources/yellow1.jpg';
import YellowPicture2 from '../../../../assets/images/learning-resources/yellow2.jpg';
import * as styles from './LearningResourcePicture.styles';

export type LearningResourcePictureProps = {
  picture?: { href: string } | null;
  children?: ReactNode;
};

const DEFAULT_PICTURES = [
  BluePicture1,
  BluePicture2,
  GoldPicture1,
  GoldPicture2,
  GreenPicture1,
  GreenPicture2,
  MeshPicture1,
  MeshPicture2,
  OrangePicture1,
  OrangePicture2,
  PinkPicture1,
  PurplePicture1,
  PurplePicture2,
  RedPicture1,
  RedPicture2,
  YellowPicture1,
  YellowPicture2,
];

export const LearningResourcePictureBase = ({
  picture = null,
  children = null,
}: LearningResourcePictureProps) => {
  const [defaultPicture] = useState(
    () => DEFAULT_PICTURES[Math.floor(Math.random() * DEFAULT_PICTURES.length)],
  );

  return (
    <div css={styles.container(picture?.href)}>
      {!picture && <img css={styles.img} src={defaultPicture} alt="resource" />}

      {children}
    </div>
  );
};

LearningResourcePictureBase.displayName = 'LearningResourcePicture';

export const LearningResourcePicture = memo(LearningResourcePictureBase);
